// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__Gt_QK","label":"Category_label__3fhvP","content":"Category_content__FnPNm","header":"Category_header__3eYN5","location":"Category_location__2FbZW"};